<template>
  <div class="owner-apply-invoice-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('ownerApplyInvoice.title')" :subtitle="$t('ownerApplyInvoice.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('ownerApplyInvoice.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 表单区 -->
    <div class="ds-panel">
      <el-form ref="form" :model="formData" label-width="150px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('ownerApplyInvoice.invoiceTitle')" required>
              <el-input v-model="formData.invoiceName" :placeholder="$t('ownerApplyInvoice.chooseInvoiceTitle')"
                disabled />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('ownerApplyInvoice.taxpayerId')" required>
              <el-input v-model="formData.invoiceNum" :placeholder="$t('ownerApplyInvoice.chooseTaxId')" disabled />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('ownerApplyInvoice.invoiceType')" required>
              <el-select v-model="formData.invoiceType" :placeholder="$t('ownerApplyInvoice.chooseInvoiceType')"
                class="w-full">
                <el-option :label="$t('ownerApplyInvoice.personal')" value="1001" />
                <el-option :label="$t('ownerApplyInvoice.enterprise')" value="2002" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('ownerApplyInvoice.addressPhone')" required>
              <el-input v-model="formData.invoiceAddress" :placeholder="$t('ownerApplyInvoice.chooseAddressPhone')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('ownerApplyInvoice.owner')" required>
              <el-input v-model="formData.ownerName" :placeholder="$t('ownerApplyInvoice.chooseContent')" disabled />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('ownerApplyInvoice.content')" required>
              <el-select v-model="formData.invoiceFlag" :placeholder="$t('ownerApplyInvoice.chooseContent')"
                class="w-full" @change="handleContentChange">
                <el-option :label="$t('ownerApplyInvoice.paidFees')" value="FEE" />
                <el-option :label="$t('ownerApplyInvoice.accountDeposit')" value="ACCT" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="ds-form-actions">
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="handleSubmit">
          {{ $t('ownerApplyInvoice.submit') }}
        </el-button>
      </div>
    </div>

    <!-- 已缴费费用 -->
    <div v-if="formData.invoiceFlag === 'FEE'" class="ds-panel">
      <ds-toolbar :total="feeDetails.length" :density="density" :show-column-setting="false" :show-refresh="false"
        @update:density="density = $event">
        <template #left>
          <span class="ds-panel__title">{{ $t('ownerApplyInvoice.paidFees') }}</span>
        </template>
        <template #right>
          <el-button type="text" size="small" @click="openSelectOwner">
            {{ $t('ownerApplyInvoice.select') }}
          </el-button>
        </template>
      </ds-toolbar>

      <ds-data-table :data="feeDetails" :loading="feeLoading" :density="density" border
        :empty-description="$t('ownerApplyInvoice.page.emptyFee')">
        <el-table-column width="55" align="center">
          <template slot-scope="scope">
            <el-checkbox :checked="formData.detailIds.includes(scope.row.detailId)"
              @change="handleFeeCheckboxChange(scope.row.detailId, $event)">
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="feeName" :label="$t('ownerApplyInvoice.feeName')" align="left" min-width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.feeName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="payerObjName" :label="$t('ownerApplyInvoice.payer')" align="center" width="140">
          <template slot-scope="scope">
            {{ scope.row.payerObjName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('ownerApplyInvoice.receivablePaid')" align="right" min-width="180">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatMoney(scope.row.receivableAmount) }} / {{ formatMoney(scope.row.receivedAmount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="primeRateName" :label="$t('ownerApplyInvoice.paymentMethod')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.primeRateName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('ownerApplyInvoice.paymentPeriod')" align="center" width="180">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatDate(scope.row.startTime) }} ~ {{ formatDate(scope.row.endTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('ownerApplyInvoice.paymentTime')" align="center" width="170">
          <template slot-scope="scope">
            {{ formatDateTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="cashierName" :label="$t('ownerApplyInvoice.cashier')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.cashierName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('ownerApplyInvoice.status')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.stateName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('ownerApplyInvoice.remark')" align="left" min-width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- 账户预存 -->
    <div v-if="formData.invoiceFlag === 'ACCT'" class="ds-panel">
      <ds-toolbar :total="acctDetails.length" :density="density" :show-column-setting="false" :show-refresh="false"
        @update:density="density = $event">
        <template #left>
          <span class="ds-panel__title">{{ $t('ownerApplyInvoice.accountDeposit') }}</span>
        </template>
        <template #right>
          <el-button type="text" size="small" @click="openSelectOwner">
            {{ $t('ownerApplyInvoice.select') }}
          </el-button>
        </template>
      </ds-toolbar>

      <ds-data-table :data="acctDetails" :loading="acctLoading" :density="density" border
        :empty-description="$t('ownerApplyInvoice.page.emptyAcct')">
        <el-table-column width="55" align="center">
          <template slot-scope="scope">
            <el-checkbox :checked="formData.arIds.includes(scope.row.arId)"
              @change="handleAcctCheckboxChange(scope.row.arId, $event)">
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="acctName" :label="$t('ownerApplyInvoice.accountName')" align="left" min-width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.acctName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="acctTypeName" :label="$t('ownerApplyInvoice.accountType')" align="center" width="130">
          <template slot-scope="scope">
            {{ scope.row.acctTypeName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" :label="$t('ownerApplyInvoice.owner')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.ownerName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="receivedAmount" :label="$t('ownerApplyInvoice.depositAmount')" align="right" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatMoney(scope.row.receivedAmount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="primeRateName" :label="$t('ownerApplyInvoice.depositMethod')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.primeRateName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('ownerApplyInvoice.totalAmount')" align="right" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatMoney(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('ownerApplyInvoice.depositTime')" align="center" width="170">
          <template slot-scope="scope">
            {{ formatDateTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <search-owner-invoice ref="searchOwnerInvoice" :visible.sync="showSearchDialog" @select="handleOwnerSelect" />
  </div>
</template>

<script>
import { queryFeeDetail, listAccountReceipt, saveInvoiceApply } from '@/api/fee/ownerApplyInvoiceApi'
import SearchOwnerInvoice from '@/components/fee/searchOwnerInvoice'
import { formatDate, formatDateTimeSec, formatMoney } from '@/utils/format'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'OwnerApplyInvoiceList',
  components: {
    SearchOwnerInvoice,
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      showSearchDialog: false,
      density: 'default',
      feeLoading: false,
      acctLoading: false,
      formData: {
        oiId: '',
        ownerId: '',
        ownerName: '',
        invoiceType: '',
        invoiceName: '',
        invoiceAddress: '',
        invoiceNum: '',
        detailIds: [],
        feeDetails: [],
        invoiceFlag: 'FEE',
        arIds: [],
        acctDetails: []
      },
      feeDetails: [],
      acctDetails: []
    }
  },
  methods: {
    formatDate,
    formatDateTimeSec(value) {
      return formatDateTimeSec(value)
    },
    formatMoney(value) {
      return formatMoney(value)
    },
    goBack() {
      this.$router.go(-1)
    },
    openSelectOwner() {
      this.showSearchDialog = true
      this.$nextTick(() => {
        this.$refs.searchOwnerInvoice.open()
      })
    },
    handleOwnerSelect(owner) {
      Object.assign(this.formData, owner)
      this.formData.detailIds = []
      this.formData.arIds = []

      if (this.formData.invoiceFlag === 'FEE') {
        this.loadFeeDetails()
      } else {
        this.loadAcctDetails()
      }
    },
    async loadFeeDetails() {
      this.feeLoading = true
      try {
        const params = {
          page: 1,
          row: 50,
          ownerId: this.formData.ownerId,
          openInvoice: 'N'
        }

        const res = await queryFeeDetail(params)
        this.feeDetails = res.feeDetails || []

        // 默认全选
        this.formData.detailIds = this.feeDetails.map(item => item.detailId)
      } catch (error) {
        console.error('Failed to load fee details:', error)
        this.$message.error(this.$t('common.loadFailed'))
      } finally {
        this.feeLoading = false
      }
    },
    async loadAcctDetails() {
      this.acctLoading = true
      try {
        const params = {
          page: 1,
          row: 50,
          ownerId: this.formData.ownerId
        }

        const res = await listAccountReceipt(params)
        this.acctDetails = res.data || []

        // 默认全选
        this.formData.arIds = this.acctDetails.map(item => item.arId)
      } catch (error) {
        console.error('Failed to load account details:', error)
        this.$message.error(this.$t('common.loadFailed'))
      } finally {
        this.acctLoading = false
      }
    },
    handleContentChange() {
      if (!this.formData.ownerId) return

      this.formData.detailIds = []
      this.formData.arIds = []

      if (this.formData.invoiceFlag === 'FEE') {
        this.loadFeeDetails()
      } else {
        this.loadAcctDetails()
      }
    },
    handleFeeCheckboxChange(detailId, checked) {
      if (checked) {
        this.formData.detailIds.push(detailId)
      } else {
        this.formData.detailIds = this.formData.detailIds.filter(id => id !== detailId)
      }
    },
    handleAcctCheckboxChange(arId, checked) {
      if (checked) {
        this.formData.arIds.push(arId)
      } else {
        this.formData.arIds = this.formData.arIds.filter(id => id !== arId)
      }
    },
    async handleSubmit() {
      try {
        // 验证表单
        if (!this.formData.ownerId) {
          this.$message.warning(this.$t('ownerApplyInvoice.chooseOwner'))
          return
        }

        if (this.formData.invoiceFlag === 'FEE' && !this.formData.detailIds.length) {
          this.$message.warning(this.$t('ownerApplyInvoice.noFeeSelected'))
          return
        }

        if (this.formData.invoiceFlag === 'ACCT' && !this.formData.arIds.length) {
          this.$message.warning(this.$t('ownerApplyInvoice.noDepositSelected'))
          return
        }

        // 准备提交数据
        const submitData = {
          ...this.formData,
          detailIds: this.formData.invoiceFlag === 'FEE' ? this.formData.detailIds : [],
          arIds: this.formData.invoiceFlag === 'ACCT' ? this.formData.arIds : []
        }

        // 调用API
        await saveInvoiceApply(submitData)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        console.error('Failed to submit invoice application:', error)
        this.$message.error(error.message || this.$t('common.submitFailed'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-apply-invoice-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-form {
  padding: var(--ds-spacing-lg) var(--ds-spacing-lg) 0;

  ::v-deep .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }

  ::v-deep .el-form-item__label {
    color: var(--ds-gray-700);
    font-weight: 500;
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
